// extracted by mini-css-extract-plugin
module.exports = {"tipWrapper":"styles_tipWrapper__RDxRF","tipWrapperInline":"styles_tipWrapperInline__mNZry"};